export   const getJambAggregate =(score:number, mode:string)=>{
    //Take 70% of UTME score, overall exam is 400
    var utme = (Number(score)/400)* 70
    //Take 70% of DE score
    var de = (Number(score)/15)* 70
  
    if(mode==='UTME'){
        return utme
    }else{
        return de
    }
  }

  export   const styles = {
    container: (css:any) => ({ ...css, flex: "1 1 auto", alignSelf: "stretch" }),
    menu: (css: any) => ({ ...css, zIndex: 99999 }),
    control: (css:any) => ({ ...css,  height:45 })
  };

  export const generateNo=(t:number)=>{
    t||(t=10);
    for(var e="",a=0;a<t;a++){
      var n=Math.floor(Math.random()*"1234567890".length);
      e+="1234567890".substring(n,n+1)
      }
     
      return e
  }
  
  
export const getRank=(i:number)=> {
  var j = i % 10,
      k = i % 100;
  if (j == 1 && k != 11) {
      return  "ST";
  }
  if (j == 2 && k != 12) {
      return  "ND";
  }
  if (j == 3 && k != 13) {
      return  "RD";
  }
  return  "TH";
}

export const getBritishDate=(dateString:any)=>{
  var months = ['January', 'February', 'March', 
  'April', 'May', 'June', 'July', 
  'August', 'September', 'October', 'November', 'December'];

var splitDate = dateString.split('-');
var month = Number(splitDate[1])-1; //Javascript months are 0-11
var surfix = getRank(splitDate[2]).toLowerCase()

let newDate = parseInt(splitDate[2])+surfix+ ' '+ months[month]+ ', '+splitDate[0]

return newDate
}